





















import { Component, Mixins, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import SpecsApi from '@/api/goods/specs'

@Component({
  components: {
    CustomForm
  }
})
export default class GoodsSpecsEdit extends AbpBase {
   validateValue(rule, value, callback) {
    var reg = /[,，]/
    if (reg.test(value)) {
      callback(new Error('内容不能包含中英文逗号'))
    }
    if (value === '') {
      callback(new Error('请输入参数值'))
    }
    callback()
  }
  filters = [
    {
      label: '规格名称：',
      type: 'input',
      rule: { required: true, message: '请输入规格名称：', trigger: 'blur' },
      key: 'name'
    },
    {
      label: '规格值：',
      key: 'productAttributeValues',
      rule: { required: true, validator: this.validateValue, trigger: 'blur' },
      settings: {
        style: {
          marginTop: '40px'
        }
      },
      renderContent: (h, item, form, _this) => {
        let $input = h('i-input', {
          props: {
            value: form['productAttributeValues'],
            type: 'textarea',
            autosize: { minRows: 6, maxRows: 10 }
          },
          style: {
            width: '240px'
          },
          ref: 'productAttributeValues',
          on: {
            input: value => {
              form['productAttributeValues'] = value
            }
          }
        })
        return h(
          'div',
          {
            style: {
              color: '#999',
              marginTop: '-24px'
            }
          },
          [
            h(
              'p',
              {
                style: {
                  color: '#999',
                  fontSize: '12px'
                }
              },
              '多个属性值用回车隔开'
            ),
            $input
          ]
        )
      }
    },
    {
      label: '备注：',
      type: 'input',
      key: 'remark'
    },
    {
      label: '规格排序：',
      type: 'input-number',
      key: 'displayOrder',
      props: {
        min: 0
      }
    }
  ]
  editId: any = null
  created() {
    if (this.$route.params['id']) {
      this.editId = this.$route.params['id']
      this.getData()
    }
  }

  onSubmit(form, valid) {
    if (valid) {
      let obj: any = {}
      let {
        displayOrder,
        productAttributeValues = '',
        name,
        remark,
        type = 0
      } = form

      productAttributeValues = productAttributeValues
        .split('\n')
        .filter(item => item !== '')
      Object.assign(obj, {
        displayOrder,
        productAttributeValues,
        name,
        type,
        remark
      })
      SpecsApi.edit(this.editId, obj).then(res => {
        this.$Message.success(this.editId ? '修改成功' : '添加成功')
        this.$router.push({ name: 'GoodsSpecs', replace: true })
      })
    }
  }

  getAttrTextByArr(arr) {
    return arr.map(item => item.name).join('\n')
  }

  getData() {
    if (!this.editId) {
      return
    }
    SpecsApi.getDataById(this.editId).then(res => {
      res.data.productAttributeValues = this.getAttrTextByArr(
        res.data.productSalesAttributeValues
      )
      ;(this.$refs.formEdit as any).setForm(res.data)
    })
  }
}
